import React from 'react';
import { ActivityType, Box, CategoryIcon, Text } from '@common-fe/common-fe';

import { TRANSACTION_TYPE_TITLES } from '@/modules/transaction/transaction.types';

interface TransactionTitleProps {
  category: string | null;
  transactionType?: string;
  children: React.ReactNode;
  testId?: string;
}

const TransactionTitle: React.FC<TransactionTitleProps> = ({
  testId = '',
  transactionType,
  category,
  children,
}) => {
  const categoryTitle = transactionType
    ? TRANSACTION_TYPE_TITLES?.[transactionType]
    : category
      ? TRANSACTION_TYPE_TITLES?.[category]
      : undefined;

  return (
    <Box direction="row" align="center" title={categoryTitle}>
      <CategoryIcon category={category as ActivityType} size="s" />
      <Text size="large" data-testId={`${testId}_title`} margin={{ left: 'spacing12' }}>
        {children}
      </Text>
    </Box>
  );
};

export default TransactionTitle;
